import {createFileRoute} from '@tanstack/react-router';

import ImagePageWithShowSamplesLink from '~components/common/ImagePageWithShowSamplesLink';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/samples/image')({
  component: ModelSamplesImagePage,
});

function ModelSamplesImagePage(): JSX.Element {
  return (
    <ModelProvider mode='model-pages'>
      <ImagePageWithShowSamplesLink />
    </ModelProvider>
  );
}
